<script>
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import BaseDatatable from '@components/base-datatable'
import WarehouseTable from '@components/retina/warehouse/warehouseTable'
import {
  sitesMethods,
  productsMethods,
  warehouseMethods,
  benchmarksMethods,
  productsReportMethods,
  groupingMethods,
  consolidatedMethods,
} from '@state/helpers'
import { mapGetters } from 'vuex'

export default {
  name: 'Consolidated',
  page: {
    title: 'Consolidated',
    meta: [
      {
        name: 'Consolidated',
        content: 'Consolidated',
      },
    ],
  },
  components: { Layout, PageHeader, BaseDatatable, WarehouseTable },
  data() {
    return {
      title: 'Configuración de Consolidados',
      items: [
        {
          text: 'Reportes',
        },
        {
          text: 'Configuración de reportes',
        },
        {
          text: 'Consolidados',
          active: true,
        },
      ],
      tableHeaders: [
        { key: 'warehouses', label: 'Grupos de Bodegas' },
        { key: 'consolidated', label: 'Consolidado', class: 'w-25' },
        { key: 'actions', label: 'Acciones' , thStyle: 'width: 120px'},
      ],
      tableHeadersWarehouse: [
        { key: 'info', label: 'Info' },
        { key: 'description', label: 'Bodega' },
        { key: 'selected', label: '', class: 'w-25' },
        // { key: 'benchmark', label: '', class: 'w-15' },
        // { key: 'actions', label: '', class: 'w-25' },
      ],
      selected: [],
      warehouses_selected: [],
      index_selected: [],
      inputConsolidated: 0,
      modalWarehouses: false,
      sendingCreateGrouping: false,
      modalDeleteGrouping: false,
      modalDeleteGroupingContent: { id: null },
      isSubmitting: false,
      request_data: [],
      modalSendConsolidated: false,
      sendingData: [],
      sendingConsolidated: false,
      editGrouping: false,
      contentEdit: [],
    }
  },
  computed: {
    ...mapGetters({
      selected_for_report: 'retina/products/selected_for_report',
    }),
  },
  methods: {
    ...consolidatedMethods,
    // ...benchmarksMethods,
    // ...productsMethods,
    ...warehouseMethods,
    myProviderWarehouse(ctx) {
      let context = this
      const promise = context.fetchWarehouses(
        this.$table_params(ctx) +
          '&paginate=true&product=' +
          this.selected_for_report.id_ext
      )
      return promise
        .then((data) => {
          data.results.forEach((warehouse, index) => {
            warehouse['selected'] = false
            if(this.editGrouping) {
              // this.contentEdit.warehouses.forEach((w, index) => {this.onRowSelected(w, index)})
              this.contentEdit.warehouses.map( (w, index) => { if(w.id_siesa == warehouse.id){ this.onRowSelected(warehouse, index) } })
            }
            if (this.selected.includes(warehouse.id)) {
              warehouse['selected'] = true
              // this.$refs.tableWarehouses.$refs.table.selectRow(index)
            }
          })
          return data
        })
        .catch((error) => {
          context.$axios_error_noty(error, context)
          return []
        })
    },
    onRowSelected(warehouses, index) {
      let items,
        id,
        name,
        company,
        nit,
        ubications,
        multi_ubication
        /* 
        warehouses: la data que lista la tabla
        items: la info que se envia al endpoint
      */
      ;({
        id,
        name,
        company,
        nit,
        ubications,
        multi_ubication,
        ...items
      } = warehouses)
      
      items['multi_location'] = ubications.length > 0 // ? true : false
      items['id_siesa'] = id

      if (this.selected.includes(warehouses.id)) {
        warehouses['selected'] = false
        this.selected = this.selected.filter((i) => i != warehouses.id)
        this.warehouses_selected = this.warehouses_selected.filter(
          (w) => w.id_siesa != items.id_siesa
        )
      } else {
        warehouses['selected'] = true
        this.selected.push(warehouses.id)
        this.warehouses_selected.push(items)
      }
    },
    ...groupingMethods,
    // ...sitesMethods,
    myProvider(ctx) {
      let context = this
      const promise = context.fetchGroupingToList(
        this.$table_params(ctx) +
        '&product=' + this.selected_for_report.id_ext)
      return promise
        .then((data) => {
          return data
        })
        .catch((error) => {
          context.$axios_error_noty(error, context)
          return []
        })
    },
    sendGroupingCreate() {
      this.sendingCreateGrouping = true
      if(this.editGrouping){
        // let formData = {}
        // formData['id']
        this.updateGrouping({id: this.contentEdit.id, formData: { warehouses: this.warehouses_selected }})
          .then((data) => {
            this.$generate_toast(this, 'success', 'Grupo de bodegas actualizado')
            this.sendingCreateGrouping = false
            this.closeModalWarehouses()
            this.$refs.tableGrouping.refresh()
          })
          .catch((error) => {
            this.$axios_error_noty(error, context)
            this.sendingCreateGrouping = false
            this.closeModalWarehouses()
          })
      }
      else {
      this.createGrouping({ warehouses: this.warehouses_selected })
        .then((data) => {
          this.$generate_toast(this, 'success', 'Grupo de bodegas creado')
          this.sendingCreateGrouping = false
          this.closeModalWarehouses()
          this.$refs.tableGrouping.refresh()
        })
        .catch((error) => {
          this.$axios_error_noty(error, context)
          this.sendingCreateGrouping = false
          this.closeModalWarehouses()
        })
      }
    },
    closeModalWarehouses() {
      this.modalWarehouses = false
      this.selected = []
      this.warehouses_selected = []
      this.editGrouping = false
      this.contentEdit = []
    },
    openModalDelete(grouping) {
      this.modalDeleteGrouping = true
      this.modalDeleteGroupingContent = grouping
    },
    resetModalDelete() {
      this.modalDeleteGroupingContent = {
        id: null,
      }
    },
    deleteReferences() {
      this.isSubmitting = true
      this.deleteGrouping(this.modalDeleteGroupingContent.id)
        .then((data) => {
          this.isSubmitting = false
          this.$generate_toast(this, 'success', 'Grupo Borrado')
          this.$refs.tableGrouping.refresh()
        })
        .catch((error) => {
          this.isSubmitting = false
          this.$axios_error_noty(error, this)
        })
    },
    updateRequestData(grouping) {
      let search = this.request_data.find((d) => d.id_grouping == grouping.id)
      if (Boolean(search)) {
        search['consolidated'] = this.$refs[grouping.id].vModelValue
      } else {
        let id,
          group,
          data = {}
        ;({ id, ...group } = grouping)
        data['id_grouping'] = id
        data['id_ext'] = this.selected_for_report.id_ext
        data['consolidated'] = this.$refs[grouping.id].vModelValue
        this.request_data.push(data)
      }
    },
    ...productsReportMethods,
    async createP() {
      await this.createProduct(this.selected_for_report)
        .then((data) => {
          this.modalSendConsolidated = false
        })
        .catch((error) => {
          this.$axios_error_noty(error, this)
        })
    },

    async createC() {
      if (this.request_data.length === 0){
        this.$generate_toast(this, 'warn', 'Sin datos para guardar, verifique!')
        return false
      }
      this.request_data.forEach(async (cons) => {
        this.sendingConsolidated = true
        const response = await this.createConsolidated(cons).then((data) => {
          this.sendingData.push(data)
          this.$generate_toast(this, 'success', 'Consolidado de producto creado/actualizado')
        })
        return response
      })
    },
    async setConsolidated() {
      this.sendingData = []
      this.modalSendConsolidated = true
      await this.createP()
      await this.createC()
      this.request_data = []
      this.sendingConsolidated = false
      this.$refs.tableGrouping.refresh()
    },
    // setValues(warehouse) {
    //   warehouse.ubications.map((ubication) => {
    //     this.$refs[ubication.id].vModelValue = this.$refs[
    //       warehouse.id
    //     ].vModelValue
    //     this.$refs[ubication.id].value = this.$refs[warehouse.id].vModelValue
    //     this.updateRequestData(warehouse, ubication, ubication.id)
    //   })
    // },
    back() {
      this.$router.push('/reports/config')
    },
    openModalWarehousesEdit(grouping) {
      // await grouping.warehouses.forEach( async (warehouse) => {
      //   await this.selected.push(warehouse.id)
      // })
      this.contentEdit = grouping
      this.editGrouping = true
      this.modalWarehouses = true
    }
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-row>
      <b-col xl="4" lg="4" >
        <b-card class="p-0">
          <b-card-title class="lead mb-3">
            <strong>
              {{ selected_for_report.name }}
            </strong>
          </b-card-title>

          <b-card-sub-title class="mb-2 lead">
            <p class="text-dark">
              Referencia: {{ selected_for_report.reference }}
            </p>
            <p v-if="selected_for_report.id_ext1" class="text-dark">
              Extensión: {{ selected_for_report.id_ext1 }}
              {{ selected_for_report.ext_description }}
            </p>
            <p v-else>
              Sin extensión
            </p>
          </b-card-sub-title>

          <b-button @click="back()" variant="link" class="text-blue">
            <i class="fas fa-arrow-left"></i> Volver
          </b-button>
        </b-card>
      </b-col>
    <!-- <div class="bg-white p-3 m-0"> -->
    <!-- <b-row>
        <b-col class="col-auto">
          <label class="lead">Consolidado:</label>
        </b-col>
        <b-col xl="3">
          <b-form-input
            v-model="inputConsolidated"
            size="sm"
            type="number"
          ></b-form-input>
        </b-col>
      </b-row> -->
    <!-- </div> -->
    <b-col lg="8" xl="8" >
      <div class="bg-white p-3 m-0">
        <h5>
          Grupo de Bodegas
        </h5>
        <div class="row mt-2">
          <b-button-group class="w-100 mb-2 col-xl-8">
            <b-button
              variant="info"
              @click="modalWarehouses = !modalWarehouses"
              class="col-md-6"  
            >
              <i class="fas fa-plus-circle"></i> Nuevo grupo
            </b-button>
          </b-button-group>
        </div>
        <BaseDatatable
          ref="tableGrouping"
          :drfprovider="myProvider"
          :tableheaders="tableHeaders"
        >
          <template v-slot:cell(warehouses)="row">
            <p
              class="p-0 m-0"
              v-for="(w, index) in row.item.warehouses"
              :key="index"
            >
              {{ w.description }}
            </p>
          </template>
          <template #cell(consolidated)="row">
            <b-form-input
              :ref="row.item.id"
              :value="row.item.consolidated_set"
              size="sm"
              type="number"
              placeholder="Establecer"
              @input="updateRequestData(row.item)"
            ></b-form-input>
          </template>
          <template #cell(actions)="row">
            <b-button
              variant="link"
              class="text-danger"
              v-b-tooltip.hover.bottom.v-danger="'Eliminar'"
              @click="openModalDelete(row.item)"
            >
              <i class="fas fa-times"></i>
            </b-button>
            <b-button
              variant="link"
              class="text-warning"
              v-b-tooltip.hover.bottom.v-warning="'Editar'"
              @click="openModalWarehousesEdit(row.item)"
            >
              <i class="far fa-edit"></i>
            </b-button>
          </template>
        </BaseDatatable>
        <div class="row mt-2">
        <div class="col text-right">
          <b-button variant="primary" @click="setConsolidated()" class="col-md-6 mr-1">
            <i class="far fa-save fa-lg mr-1"></i> Guardar
          </b-button>
        </div>
      </div>
      </div>
    </b-col>
  </b-row>
    <b-modal
      hide-header
      hide-footer
      :busy="sendingCreateGrouping"
      size="xl"
      v-model="modalWarehouses"
    >
      <h5 class="mt-3">
        Bodegas seleccionadas:
        <b-badge variant="blue"> {{ selected.length }} </b-badge>
      </h5>
      
      <WarehouseTable
        ref="tableWarehouses"
        selectable
        select-mode="multi"
        :striped="false"
        :drfprovider="myProviderWarehouse"
        :tableheaders="tableHeadersWarehouse"
        :rowSelected="onRowSelected"
      >
        <template v-slot:cell(info)="row">
          <span class="text-blue">{{ row.item.code }}</span>
        </template>
        <template v-slot:cell(description)="row">
          {{ row.item.description }}
        </template>
        <template #cell(selected)="row">
          <template v-if="row.item.selected">
            <i class="fas fa-check-circle fa-lg text-success"></i>
          </template>
        </template>
      </WarehouseTable>
      <!-- {{warehouses_selected}} -->
      <div class="row mt-2">
        <div class="col text-right">
          <b-button variant="secondary" @click="closeModalWarehouses()" class="mr-1">
            <i class="fas fa-times-circle"></i> Cancelar
          </b-button>
          <b-button variant="primary" @click="sendGroupingCreate()">
            <i class="fas fa-check-circle"></i> {{this.editGrouping ? 'Actualizar' : 'Crear'}}
          </b-button>
        </div>
      </div>
    </b-modal>
    <b-modal
      v-model="modalDeleteGrouping"
      title="Borrar Grupo"
      ok-title="Borrar"
      ok-variant="danger"
      @hidden="resetModalDelete()"
      @ok="deleteReferences()"
    >
      <p>
        ¿Esta seguro de Borrar el grupo?
      </p>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button size="sm" variant="secondary" @click="cancel">
          Cancelar
        </b-button>
        <b-button
          size="sm"
          variant="danger"
          :disabled="isSubmitting"
          @click="ok"
        >
          <span v-if="!isSubmitting">
            {{ $t('delete') }}
          </span>
          <b-spinner v-if="isSubmitting" small label="Spinning" variant="light">
          </b-spinner>
        </b-button>
      </template>
    </b-modal>
    <b-modal
      ok-only
      no-close-on-backdrop
      no-close-on-esc
      hide-header
      size="xl"
      :busy="sendingConsolidated"
      v-model="modalSendConsolidated"
      @hidden="request_data = []"
    >
      <p>Enviando</p>
      <ul>
        <li
          v-for="(consolid, index) in sendingData"
          :key="index"
          class="text-success"
        >
          <p
            class="p-0 m-0"
            v-for="(w, index) in consolid.grouping.warehouses"
            :key="index"
          >
            {{ w.description }}
          </p>
          <p class="p-0 m-0 ml-4">
            Consolidado: {{ consolid.consolidated }} -
            <i class="fas fa-check-circle"></i>
          </p>
        </li>
      </ul>
    </b-modal>
  </Layout>
</template>
